import React, {Component} from 'react';
import {connect} from 'react-redux';
import {setFilterValues} from '../../containers/Layouts/Admin/dashboard/actions';

class ColumnViewFilters extends Component {
    state={
        listItems: [
            {   key: 'id',
                label: "Case ID",
                checked: true,
            },
            {   key: "dateOfSubmission",
                label: "Submission Date",
                checked: true,   
            },
            {   key: "sendingDate",
                label: "Sending Date",
                checked: true,   
            },
            {   key: "dateOfReturn",
                label: "Return Date",
                checked: true,   
            },
            {   key: "dentist",
                label: "Dentist",
                checked: true,   
            },
            {   key: "numberOfUnits",
                label: "Units",
                checked: true,
            },
            {   key: "patient",
                label: "Patient",
                checked: true,   
            },
            {   key: "type",
                label: "Type",
                checked: true,   
            },
            {   key: "status",
                label: "Status",
                checked: true,
            },
            {   key: "numberOfImages",
                label: "Photos",
                checked: true,   
            },
            {   key: "createdBy",
                label: "Created by",
                checked: true,   
            },
            {   key: "history",
                label: "History",
                checked: true,   
            },
            {   key: "actions",
                label: "Actions",
                checked: true,   
            }
        ],
    }

    componentDidMount() {
        this.setListItemsData();
    }
    
    setListItemsData = () => {
        const {tableConfig, isAdmin, tableConfigDentist} = this.props;
        let config = isAdmin ? tableConfig : tableConfigDentist;
        const dataItems = [...this.state.listItems]
            const dataArr = dataItems.filter(item => {
                if(typeof config[item.key] === 'boolean'){
                    item.checked = config[item.key]
                    return true;
                }
                return false
            })
            this.setState({
                listItems: dataArr
            })
    }

    checkFilters = (e,key) => {
        this.setState({
            listItems: this.state.listItems.map(item => {
                return key === item.key ? {...item, checked: !item.checked} : item;
            })
        })
    }

    updateTableConfig = (e) => {
        const {isAdmin} = this.props;
        const data = {};
        const {listItems} = this.state;
        for(let item of listItems){
            data[item.key] = item.checked
        }
        this.props.setFilterValues({data, isAdmin});
        this.props.onDiscard(e)
    }

    render() {
        const { listItems } = this.state;
        const { onDiscard } = this.props;

        return (
            <div id='parent-wrapper'>
                <img src={require('./up-arrow.svg')} alt='arrow up'/>
                <ul id='column-view-filters'>
                   { listItems.map(listItem => (
                       <li key={listItem.key}>
                           <div className="checkbox custom-control custom-checkbox">
                               <input
                                   id=""
                                   type="checkbox"
                                   className="custom-control-input"
                                   name="type"
                                   onChange={(e) => {this.checkFilters(e,listItem.key)}}
                                   checked={listItem.checked}
                               />
                               <label htmlFor="" className="checkbox-label custom-control-label">
                                   {listItem.label}
                               </label>
                           </div>
                       </li>
                   )) }
                </ul>
                <div className='button-wrapper'>
                    <button onClick={onDiscard} className="no-shadow-btn btn btn-outline">Discard</button>
                    <button onClick={this.updateTableConfig} className="no-shadow-btn btn btn-primary" style={{marginLeft: '10px'}}>Save</button>
                </div>
            </div>
            )
    }
}

const mapStateToProps = (state) => ({
    tableConfig: state.adminDashboard.tableConfig,
    tableConfigDentist: state.home.tableConfigDentist,
})

const dispatchToProps = (dispatch) => {
    return {
        setFilterValues: (key) => dispatch(setFilterValues(key)),
    }
}
export default connect(mapStateToProps, dispatchToProps)(ColumnViewFilters);


// WEBPACK FOOTER //
// ./src/components/ColumnViewFilters/index.js